module.exports = __webpack_public_path__ + "4b0f9af27551a277b61eb4c865cb0b20.svg";